import { defineStore } from 'pinia'
import axios from 'axios'
import { preferredPaymentMethodsMap } from '@/helpers/constants'
import { env } from '@/helpers/environment'
import { dailyStorage, sharedKeyPersist } from './persistence'

export const usePaywallStore = defineStore('paywall', {
	state: () => ({
		purchasedProduct: null,
		socialProof: null,
		promocode: null,
		removeDiscountAfterCountdown: null,
		overridenTabsOrder: null,
		overridenDefaultPaymentTab: null,
		countdown: null,
		countdownIsVisible: false,
		countdownFinishedAt: null,
		seamlessPurchase: {
			enabled: false,
			loading: false,
			passed: false,
		},
		freeWorkbook: {
			id: null,
			title: null,
			campaignID: null,
		},
		lastUsedProvider: null,
		taxes: {
			initialized: false,
			paidByUser: false,
			coverageModalOpen: false,
		},
		glpCheckoutModalOpen: false,
	}),

	getters: {
		getPromocode(state) {
			return state.promocode
		},

		getSeamlessPurchase(state) {
			return state.seamlessPurchase
		},

		getFreeWorkbook(state) {
			return state.freeWorkbook
		},

		getLastUsedProvider(state) {
			return state.lastUsedProvider
		},

		getSocialProof(state) {
			return state.socialProof
		},

		getGlpCheckoutModalOpen(state) {
			return state.glpCheckoutModalOpen
		},
	},

	actions: {
		setPurchasedProduct(product) {
			this.purchasedProduct = product
		},

		setPromocode(promocode) {
			this.promocode = promocode
		},

		setRemoveDiscountAfterCountdown(status) {
			this.removeDiscountAfterCountdown = status
		},

		setOverridenTabs(preferredPaymentMethod) {
			if (!preferredPaymentMethodsMap[preferredPaymentMethod]) {
				return
			}

			this.overridenTabsOrder = preferredPaymentMethodsMap[preferredPaymentMethod].tabsOrder
			this.overridenDefaultPaymentTab = preferredPaymentMethodsMap[preferredPaymentMethod].defaultPaymentTab
		},

		updateCountdown(value) {
			this.countdown = value
		},

		toggleCountdown(value) {
			this.countdownIsVisible = value
		},

		setCountdownFinishedAt(finishedAt) {
			this.countdownFinishedAt = finishedAt
		},

		setSeamlessPurchase({ enabled, loading, passed }) {
			if (enabled !== undefined) {
				this.seamlessPurchase.enabled = enabled
			}
			if (loading !== undefined) {
				this.seamlessPurchase.loading = loading
			}
			if (passed !== undefined) {
				this.seamlessPurchase.passed = passed
			}
		},

		setFreeWorkbook({ id, title, campaignID }) {
			this.freeWorkbook = { id, title, campaignID }
		},

		setLastUsedProvider(provider) {
			this.lastUsedProvider = provider
		},

		setTaxesInitialized(value) {
			this.taxes.initialized = value
		},

		setTaxPaidByUser(value) {
			this.taxes.paidByUser = value
		},

		setTaxCoverageModalOpen(value) {
			this.taxes.coverageModalOpen = value
		},

		setSocialProof(data) {
			this.socialProof = data
		},

		incrementSocialProofCount(increment) {
			if (this.socialProof) {
				this.socialProof.count += increment
			}
		},

		setGlpCheckoutModalOpen(isOpen) {
			this.glpCheckoutModalOpen = isOpen
		},

		async setPromocodeByName(promocode) {
			try {
				const { data } = await axios.get(`${env('BILLING_API_HOST')}/v1/promocodes/${promocode}`)
				this.promocode = data
			} catch (e) {
				this.promocode = null
				throw e
			}
		},
	},

	persist: sharedKeyPersist('onedaystorage', 'paywall', dailyStorage),
})
